import { gql } from 'graphql-tag'
import { dailySalesIncentivesReportFragment } from '../reporting/incentiveSales/incentiveSalesQueries'

const dashBoardStatsFragment = gql`
  fragment DashBoardStatsFragment on DashboardStatsType {
    actual
    target
    chainTarget
  }
`

const dailySalesStatsFragment = gql`
  fragment DailySalesStatsFragment on DailySalesStats {
    actual
    target
    actualLastUpdatedAt
  }
`

export const fetchDashboardStats = gql`
  query FetchDashboardStats($stationId: ID!, $date: String) {
    oldDashboard(stationId: $stationId, date: $date) {
      dailySales {
        ...DailySalesStatsFragment
      }
      salesIncentive {
        ...DashBoardStatsFragment
      }
      averageFeelingMeter
    }
  }
  ${dashBoardStatsFragment}
  ${dailySalesStatsFragment}
`

export const fetchFrontPage = gql`
  query FetchFrontPage(
    $stationId: ID!
    $date: String!
    $fromDate: String!
    $toDate: String!
    $startOfMonth: String!
    $endOfMonth: String!
  ) {
    oldDashboard(stationId: $stationId, date: $date) {
      dailySales {
        ...DailySalesStatsFragment
      }
      salesIncentive {
        ...DashBoardStatsFragment
      }
      averageFeelingMeter
      feelingsCount
    }
    reservations: weeksReservations(stationId: $stationId, date: $date) {
      id
      startTime
      endTime
      name
      peopleCount
      otherInfo
      room
      contactName
      contactPhone
      paymentMethod
      reservationType
      mealOptionDescription
    }
    weeklyIncentiveSales: reportDailySalesIncentives(stationId: $stationId, fromDate: $fromDate, toDate: $toDate) {
      ...dailySalesIncentivesReportFragment
    }
    monthlyIncentiveSales: reportDailySalesIncentives(
      stationId: $stationId
      fromDate: $startOfMonth
      toDate: $endOfMonth
    ) {
      ...dailySalesIncentivesReportFragment
    }
    campaigns(date: $date, stationId: $stationId, includeChainCampaigns: true) {
      id
      name
      startTime
      endTime
      description
      offers {
        buy {
          productGroups {
            quantity
            products
          }
        }
        get {
          totalPrice
          productGroups {
            quantity
            discountAmount
            discountPercent
            priceAmount
            products
          }
        }
      }
    }
    restaurantMenuPeriods: expressCheckoutCategoryPeriods(stationId: $stationId) {
      categoryId
      periodName
      startDate
      endDate
    }
    restaurantMenu: expressCheckoutMenu(stationId: $stationId) {
      categories {
        id
        name
      }
    }
  }
  ${dashBoardStatsFragment}
  ${dailySalesStatsFragment}
  ${dailySalesIncentivesReportFragment}
`

export const exportReservations = gql`
  mutation ExportReservations($stationId: ID!, $date: String!) {
    exportReservations(stationId: $stationId, date: $date)
  }
`
